module.exports = __webpack_public_path__ + "static/media/avatar5.b830052a.jpg";